<template>
  <div class="landing-card">
    <div class="flex">
      <h2>Twoje Wirtualne Biuro</h2>
      <router-link to="/pakiety" title="Sprawdź pakiety">sprawdź pakiety</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingCard',
}
</script>

<style scoped lang="scss">
  div.landing-card { width: 100%; height: 600px; margin-top: 60px; background: url('../assets/banner.webp') no-repeat 50% 50%; background-size: 100% 100%; }
  div.landing-card h2 { margin: -130px 0 0; padding: 0; font-family: 'Aspergit Regular', sans-serif; color: #fff; font-size: 100px; text-shadow: 7px 7px 10px #221f1f; 
    letter-spacing: 2px; font-weight: 500; text-align: center; }
  div.landing-card div.flex { display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; }
  div.landing-card a { display: block; margin-top: 50px; padding: 15px 40px; border: 0; background: 0; color: #fff; border: 1px solid #fff; border-radius: 25px; 
    font-size: 12px; text-transform: uppercase; font-weight: 500; cursor: pointer; letter-spacing: 1px; text-decoration: none; 
    animation-name: shadowChangeWhite; animation-duration: 4s; animation-iteration-count: infinite;}
  div.landing-card a:hover { background: #fff; color: #000; font-weight: 400; }

  @media (max-width: 1100px) {
    div.landing-card h2 { font-size: 70px; }
    div.landing-card { height: 400px; }
    div.landing-card { background: url('../assets/banner_1100x400.webp') no-repeat 50% 50%; }
  }

  @media (max-width: 700px) {
    div.landing-card h2 { font-size: 50px; }
    div.landing-card a { padding: 15px 34px; font-size: 11px; }
  }

  @media (max-width: 400px) {
    div.landing-card h2 { font-size: 40px; }
    div.landing-card { height: 300px; }
    div.landing-card { background: url('../assets/banner_400x300.webp') no-repeat 50% 50%; }
    div.landing-card h2 { margin: 0; }
  }
</style>